module.exports = __webpack_public_path__ + "static/img/solutionValuePic04.3de5a0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionValuePic04.png
// module id = DlhI
// module chunks = 0